import React from 'react'

const CenterManagement = () => {
  return (
    <div
    style={{
      width: "100%",
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      fontSize: "2rem",
    }}
  >
    Under Development
  </div>
  )
}

export default CenterManagement